// The only place navigation icons come from (redesign.md §5): Lucide,
// stroke 1.75, 18px in the sidebar, 16px inline. Pages and the shell never
// pick nav icons ad hoc.
import {
  Activity, ArrowLeftRight, Mail, Rss, SearchCheck, Workflow, Languages, SpellCheck, BadgePercent, Bell, Blocks, Boxes, Building2, ChartNoAxesCombined, ClipboardCheck, ClipboardList, CreditCard,
  FileText, Gift, Globe, HandCoins, Images, Landmark, LayoutDashboard, LayoutGrid, LifeBuoy, ListTree, MessageSquareText, Newspaper,
  Package, PanelsTopLeft, Plug, Power, ReceiptText, Rocket, ScanSearch, ScrollText, Send, Settings2, Shapes, ShieldCheck, ShoppingBag, ShoppingCart, Star, Radio, Table2, MousePointerClick, ToggleRight, Undo2,
  SlidersHorizontal, Sparkles, Store, TicketPercent, Truck, UserCog, UserRound, UsersRound, Wallet, Warehouse, type LucideIcon,
} from "lucide-react";

export const navIcons = {
  // modules
  overview: LayoutDashboard,
  commerce: Boxes,
  people: UsersRound,
  growth: Sparkles,
  storefront: Store,
  insights: ChartNoAxesCombined,
  finance: Wallet,
  settings: Settings2,
  help: LifeBuoy,
  // items
  orders: ReceiptText,
  manualOrders: ClipboardList,
  recoveredCarts: ShoppingCart,
  catalog: Package,
  collections: LayoutGrid,
  giftCards: Gift,
  inventory: Warehouse,
  stockCounts: ClipboardCheck,
  transfers: ArrowLeftRight,
  purchaseOrders: ScrollText,
  customers: UsersRound,
  segments: Blocks,
  messages: MessageSquareText,
  campaigns: Send,
  emailCampaigns: Mail,
  automations: Workflow,
  feeds: Rss,
  seo: SearchCheck,
  discounts: TicketPercent,
  themes: Store,
  features: ToggleRight,
  reviews: Star,
  returns: Undo2,
  pages: FileText,
  menus: ListTree,
  blog: Newspaper,
  files: Images,
  preferences: SlidersHorizontal,
  searchDiscovery: ScanSearch,
  translate: SpellCheck,
  customContent: Shapes,
  analytics: ChartNoAxesCombined,
  reports: Table2,
  live: Radio,
  customerEvents: MousePointerClick,
  // settings groups and sections
  business: Building2,
  selling: ShoppingBag,
  operations: Truck,
  privacy: ShieldCheck,
  account: UserCog,
  storeProfile: Building2,
  storeStatus: Power,
  policies: ScrollText,
  languages: Languages,
  invoices: FileText,
  paymentMethods: CreditCard,
  checkout: ShoppingCart,
  shipping: Truck,
  taxes: Landmark,
  warehouses: Warehouse,
  inventorySettings: Package,
  notifications: Bell,
  customFields: PanelsTopLeft,
  customerAccounts: UserRound,
  customerPrivacy: ShieldCheck,
  team: UserCog,
  subscription: HandCoins,
  billing: ReceiptText,
  domains: Globe,
  activity: Activity,
  apps: Plug,
  quickAction: Rocket,
  discount: BadgePercent,
} satisfies Record<string, LucideIcon>;

export type NavIcon = keyof typeof navIcons;

export const NAV_STROKE = 1.75;
